import type { ComponentPropsWithoutRef } from "react";
import { type JSX, memo } from "react";
import { currentColors } from "../../colors";

type IOwnProps = {
    number?: number;
    color?: string;
};

type IProps = IOwnProps & ComponentPropsWithoutRef<"svg">;

function ImagePinIcon({ number, color = currentColors.selectInImage, ...props }: IProps): JSX.Element {
    return (
        <svg
            clipRule="evenodd"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            viewBox="0 0 22 44"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <ellipse cx="10.897" cy="10.797" fill="#fff" rx="10.271" ry="10.425" />
            <path
                d="m1.046 13.751c-.273-.936-.419-1.928-.419-2.954 0-5.753 4.602-10.425 10.27-10.425 5.669 0 10.271 4.672 10.271 10.425 0 1.298-.234 2.541-.662 3.688l-9.506 29.143-9.973-29.894c.006.006.012.012.019.017zm9.851-11.412c-4.599 0-8.333 3.79-8.333 8.458 0 4.669 3.734 8.459 8.333 8.459 4.6 0 8.334-3.79 8.334-8.459 0-4.668-3.734-8.458-8.334-8.458z"
                fill={color}
            />
            {number && (
                <text fill={color} x="11" y="14" textAnchor="middle" fontSize="12">
                    {number}
                </text>
            )}
        </svg>
    );
}

export default memo(ImagePinIcon);
